import React from 'react';
import { Badge } from 'components/ui/badge';
import { Icon } from 'components/ui/icon';
import {
  REFUND_STATUS,
  STATUS_AUTHORIZED,
  STATUS_CANCELED,
  STATUS_COMPLETED,
  STATUS_INITIATED,
  STATUS_REFUND_FAILED,
  STATUS_REFUND_INITIATED,
  STATUS_REFUND_SUCCESSFUL,
  STATUS_RETURNED,
  STATUS_RISKY,
  STATUS_SETTLED,
  STATUS_SETTLEMENT_INITED,
  STATUS_SETTLEMENT_SUBMITTED,
  STATUS_SUCCESS,
  STATUS_SUSPENDED,
  STATUS_PAYOUT_INITED,
  STATUS_PAYOUT_SUBMITTED,
  STATUS_PAYOUT_SETTLED,
  STATUS_PAYOUT_FAILED,
  STATUS_WRITE_OFF,
  STATUS_MEDIUM_RISK,
  GTW_STATUS,
  GTW_TRANSACTION_TYPE,
} from './constants';

export const payoutsStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === STATUS_PAYOUT_INITED) {
    return <Badge variant="info">Pending</Badge>;
  }
  if (cell === STATUS_PAYOUT_SUBMITTED) {
    return <Badge variant="info">Initiated</Badge>;
  }
  if (cell === STATUS_PAYOUT_SETTLED) {
    return <Badge variant="success">Successful</Badge>;
  }
  if (cell === STATUS_PAYOUT_FAILED) {
    return <Badge variant="danger">Failed</Badge>;
  }
  return <Badge variant="info">Pending</Badge>;
};

export const gatewatTransactionStatusFormatter = (status?: string) => {
  switch (status) {
    case GTW_STATUS.STARTED:
    case GTW_STATUS.PENDING:
      return <Badge variant="info">Initiated</Badge>;
    case GTW_STATUS.SUCCESS:
    case GTW_STATUS.APPROVED:
      return <Badge variant="success">Successful</Badge>;
    case GTW_STATUS.REFUNDED:
      return <Badge variant="refund">Refunded</Badge>;
    case GTW_TRANSACTION_TYPE.REFUND:
      return <Badge variant="refund">Refund</Badge>;
    case GTW_STATUS.CANCELED:
    case GTW_STATUS.VOIDED:
      return <Badge variant="disabled">Canceled</Badge>;
    case GTW_STATUS.DECLINED:
    case GTW_STATUS.ERROR:
    case GTW_STATUS.TERMINAL_BUSY:
    case GTW_STATUS.TERMINAL_ERROR:
      return <Badge variant="danger">Failed</Badge>;
    case GTW_STATUS.NOT_FOUND:
      return <Badge variant="danger">Lost</Badge>;
    default:
      return <></>;
  }
};

export const transactionStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === STATUS_INITIATED) {
    return <Badge variant="info">ACH Initiated</Badge>;
  }
  if (cell === STATUS_AUTHORIZED) {
    return <Badge variant="progress">ACH Authorized</Badge>;
  }

  if (
    cell === STATUS_SUCCESS ||
    cell === 'settled' ||
    cell === 'finalized ' ||
    cell === 'finalized' ||
    cell === 'success'
  ) {
    return <Badge variant="success">Successful</Badge>;
  }
  if (cell === STATUS_RETURNED || cell === STATUS_WRITE_OFF) {
    return <Badge variant="danger">ACH Returned</Badge>;
  }
  if (cell === STATUS_CANCELED) {
    return <Badge variant="disabled">Canceled</Badge>;
  }
  if (cell === STATUS_COMPLETED) {
    return <Badge variant="danger">Lost</Badge>;
  }
  if (cell === STATUS_REFUND_INITIATED) {
    return <Badge variant="info">Refund Initiated</Badge>;
  }
  if (cell === STATUS_REFUND_SUCCESSFUL) {
    return <Badge variant="success">Refund Successful</Badge>;
  }
  if (cell === STATUS_REFUND_FAILED) {
    return <Badge variant="danger">Refund Failed</Badge>;
  }
  return <Badge variant="progress">Dropped</Badge>;
};

export const settlementStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (
    cell === STATUS_SETTLEMENT_INITED ||
    cell === STATUS_SETTLEMENT_SUBMITTED
  ) {
    return <Badge variant="info">ACH Initiated</Badge>;
  }
  if (cell === STATUS_SETTLED) {
    return <Badge variant="success">Successful</Badge>;
  }
  return <Badge variant="danger">Failed</Badge>;
};

export const customerStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === STATUS_SUSPENDED) {
    return <Badge variant="progress">Suspended</Badge>;
  }
  if (cell === STATUS_RISKY) {
    return <Badge variant="danger">High Risk</Badge>;
  }
  if (cell === STATUS_MEDIUM_RISK) {
    return <Badge variant="danger">Medium Risk</Badge>;
  }
  return <Badge variant="info">Active</Badge>;
};

export const APIKeysStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === 'active') {
    return <Badge variant="info">ACTIVE</Badge>;
  }
  return <Badge variant="danger">DELETED</Badge>;
};
export const webhooksStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === 'active') {
    return <Badge variant="info">ACTIVE</Badge>;
  }
  return <Badge variant="disabled">INACTIVE</Badge>;
};

export const paymentProviderStatusFormatter = (cell: boolean): JSX.Element => {
  if (cell) {
    return <Badge variant="info">APPROVED</Badge>;
  }
  return <Badge variant="progress">DISABLED</Badge>;
};

export const defaultProcessorCheckFormatter = (isDefault: boolean): JSX.Element => {
  if (isDefault) {
    return (
      <Icon
        name="check"
        size={24}
        strokeWidth={2.5}
        className="text-[#006aff] ml-[22px]"
      />
    );
  }
  return <></>;
};

// export const paymentLinkStatusFormatter = (
//   cell: string | undefined
// ): JSX.Element => {
//   if (cell === 'successful') {
//     return <Badge variant="info">SUCCESSFUL</Badge>;
//   }
//   return <Badge variant="progress">PAUSED</Badge>;
// };

export const WebhookEventStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === 'success') {
    return <Badge variant="success">Successful</Badge>;
  }
  return <Badge variant="danger">Failed</Badge>;
};

export const refundsStatusFormatter = (
  cell: string | undefined
): JSX.Element => {
  if (cell === REFUND_STATUS.SUCCEEDED) {
    return <Badge variant="success">Successful</Badge>;
  }
  if (cell === REFUND_STATUS.PENDING) {
    return <Badge variant="info">Initiated</Badge>;
  }
  return <Badge variant="danger">Failed</Badge>;
};

export const payoutStatusFormatter = (cell: string): JSX.Element => {
  switch (cell) {
    /**
     * initiated & pending mean the same - two statuses used by Synctera
     * Both are mapped to 'initiated' on FE
     */
    case 'inited':
      return <Badge variant="info">Initiated</Badge>;
    case 'settled':
      return <Badge variant="success">Successful</Badge>;
    case 'failed':
      return <Badge variant="disabled">Failed</Badge>;
    default:
      return <></>;
  }
};

export const AmountChangePercentLabel = ({ value = 0 }): JSX.Element => {
  const floatValue = `${value.toFixed(1).replace('-', '')}%`;

  return value > 0 ? (
    <Badge variant="success" className="gap-0.5">
      <Icon name="arrow-up" size={16} aria-hidden="true" />
      <span>{floatValue}</span>
    </Badge>
  ) : value === 0 ? (
    <Badge variant="disabled">
      <span>{floatValue}</span>
    </Badge>
  ) : (
    <Badge variant="danger" className="gap-0.5">
      <Icon name="arrow-down" size={16} aria-hidden="true" />
      <span>{floatValue}</span>
    </Badge>
  );
};
